import React, { createContext, useContext, useEffect, useState } from "react";

const AppFeaturesContext = createContext({
  promotionModule: false,
  loaded: false,
});

export async function loadAppFeatures() {
  const result = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/app/features`
  );
  const json = await result.json();
  if (!json?.success) {
    throw new Error(json?.message || "Failed to load app features");
  }
  return {
    promotionModule:
      json.data?.promotionModule === true ||
      json.data?.promotionTrack === true,
  };
}

export const AppFeaturesProvider = ({ children }) => {
  const [features, setFeatures] = useState({
    promotionModule: false,
    loaded: false,
  });

  useEffect(() => {
    let cancelled = false;
    loadAppFeatures()
      .then((data) => {
        if (!cancelled) setFeatures({ ...data, loaded: true });
      })
      .catch(() => {
        if (!cancelled) {
          setFeatures({ promotionModule: false, loaded: true });
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <AppFeaturesContext.Provider value={features}>
      {children}
    </AppFeaturesContext.Provider>
  );
};

export const useAppFeatures = () => useContext(AppFeaturesContext);

export const usePromotionModuleEnabled = () =>
  useAppFeatures().promotionModule === true;

export const usePromotionTrackEnabled = usePromotionModuleEnabled;
